export const WKDA_LEAD_COOKIE = 'wkdaLead';
export const SCID_COOKIE = 'SCID';
export const ONE_YEAR_IN_SECONDS = 3600 * 24 * 365;